import { cn } from '@/lib/utils';
import { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  label?: ReactNode;
  className?: string;
  actions?: ReactNode;
}

export function Card({ label, children, className, actions }: CardProps) {
  return (
    <section
      className={cn('flex flex-col bg-white dark:bg-gray-800 shadow-sm rounded-xl px-5 py-4 space-y-2', className)}
    >
      {Boolean(label) && (
        <header className="pb-4 -mx-5 px-5 border-b mb-4 border-gray-100 dark:border-gray-700/60 flex items-center justify-between">
          {/* Left side */}
          <h2 className="font-semibold text-gray-800 dark:text-gray-100">{label}</h2>

          {/* Right side */}
          <div>{actions}</div>
        </header>
      )}
      {children}
    </section>
  );
}

interface CardRowProps {
  label: ReactNode;
  value: ReactNode;
}

export function CardRow({ label, value }: CardRowProps) {
  return (
    <div className="flex justify-between items-center">
      <div className="text-sm">{label}</div>
      <div>{value}</div>
    </div>
  );
}
